module.exports = __webpack_public_path__ + "media/partenaire/demo-3bd42580.png";